import css from 'styled-jsx/css';
import colors from '../../../config/colors';
import font from "../../../config/fonts";
export const ButtonGroupStyle = css`
	.left-btn {
		font-family: ${font.bold} !important;
		font-weight: 500;
		font-size: 1rem;
		float: left;
		width: 50%;
		border: solid 0.6px ${colors.Grey20};
		height: 50px;
		text-align: center;
		background-color: ${colors.White0};
	}
	.right-btn {
		font-family: ${font.bold} !important;
		font-weight: 700;
		font-size: 1rem;
		float: right;
		border: solid 0.6px ${colors.Grey20};
		border-left: none;
		width: 50%;
		height: 50px;
		text-align: center;
		background-color: ${colors.White0};
	}
	.left-btn-md {
		font-family: ${font.medium} !important;
		font-weight: 700;
		font-size: 1rem;
		float: left;
		padding-left: 1rem;
		width: 48%;
		box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
		border: solid 0.6px ${colors.Grey20};
		height: 3.125rem;
		text-align: left;
        background-color: ${colors.White0};
		border-radius: 4px;
		padding-right: 0;
    display: flex;
    align-items: center;
	}
	.right-btn-md {
		font-family: ${font.medium} !important;
		font-weight: 700;
		font-size: 1rem;
		padding-left: 1rem;
		float: right;
		box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
		border: solid 0.6px ${colors.Grey20};
		min-width: 48%;
		height: 3.125rem;
		text-align: left;
        background-color: ${colors.White0};
		border-radius: 4px;
		padding-right: 0;
	}
	.right-arrow {
		margin-top: 0.4rem;
		width: 0.6875rem;
		height: 0.6875rem;
		float: right;
		margin-right: 0.9375rem;
	}
	.button-text {
		font-family: ${font.regular};
		font-weight: 400;
		color:${colors.Grey70}
	}
	.button-image {
		width: 1.1875rem;
		height: 1.1875rem;
    }
    .button-label {
        color: ${colors.Black40};
        font-family: ${font.medium};
        font-size: 1rem;
        font-weight: 500;
        margin: 0 0.3rem 0 0.5rem;
	}
	.button-grid-gutter {
		margin-left: -1rem !important;
		margin-right: -1rem !important;
    }
	.no-shadow {
		box-shadow: none;
		border-color: ${colors.Black40};
		padding-left: 0rem;
		text-align: center;
	}
    @media screen and (max-width: 576px) {
        .left-btn-md, .right-btn-md {
            width: 100%;
            float: none;
			text-align: center;
        }
        .right-btn-md {
            margin-top: 0.5rem;
        }
    }
    @media screen and (max-width: 320px) {
        .right-arrow {
            padding-right: 0;
        }
    }
    @media screen and (min-width: 768px) {
        .right-btn-md,
        .left-btn-md {
            width: 21.75rem;
		}
    }
`;
